export { default as fromState } from './epic';
